<template>
  <div class="indexCont">
    <div class="mainCont">
      <div class="btnArr">
        <el-button type="primary" size="small">
          待考试({{dataInfo.total}})
        </el-button>
        <el-button size="small" @click="goPage('./alreadyTest')">
          已考试({{alreadyTotal}})
        </el-button>
      </div>
      <div class="testCont">
        <el-table
          :data="dataList"
          stripe
          style="width: 100%"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-text="拼命加载中"
        >
          <el-table-column align="center" label="序号" type="index"></el-table-column>
          <el-table-column prop="paperName" align="center" label="试卷名称" ></el-table-column>
          <el-table-column prop="parentCategoryName" align="center" label="试卷类型"></el-table-column>
          <el-table-column prop="categoryName" align="center" label="考试科目"></el-table-column>
          <el-table-column prop="limitTime" align="center" label="考试时长"></el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <!-- scope.row：代表这一行数据的对象 -->
              <div class="testDetail" @click="goPage('./goTest?companyId='+ scope.row.companyId +'&paperId=' + scope.row.paperId + '&url=test' + '&curPage=' + curPage)">
                去考试
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="dataInfo.total"
          @current-change="changePage"
          ref="pagination"
        ></el-pagination>
      </div>
    </div>
    <!-- 移动端显示 -->
    <div class="mobileTest">
      <MobileComNav title="我的考试" url="./index"></MobileComNav>
      <div class="switchTest">
        <div class="active">待考科目</div>
        <div @click="goPage('./alreadyTest')">已考科目</div>
      </div>
      <div class="mt_cont">
        <div class="mt_item" v-for="(item,index) in dataList" :key="index">
          <div class="title">{{item.paperName}}</div>
          <div class="time">考试时长：{{item.limitTime}}分钟</div>
          <div class="status">
            考试状态：
            <span class="addColor">未考试</span>
          </div>
          <div class="btn" @click="goPage('./goTest?companyId='+ item.companyId +'&paperId=' + item.paperId + '&url=test')">去考试</div>
        </div>
      </div>
      <div class="comTxt" v-show="isShow">暂无数据</div>
    </div>
  </div>
</template>

<script>
import MobileComNav from "../../../components/mobileHead";
import getQuery from "../../../assets/js/libs/getQuery.js";
export default {
  data() {
    return {
      loading: true,
      dataInfo:{},
      dataList:[],
      curPage: 1,
      isShow:false,
      pageSize:10,
      alreadyTotal:""
    };
  },
  mounted() {
    document.title = this.$route.meta.title;
  },
  components: {
    MobileComNav
  },
  created() {
    if(this.$IsPc()){
      this.pageSize = 10000;
    };
    if(window.location.href.indexOf('curPage') > -1){
      this.curPage = getQuery('curPage')
    }
    //动态改变页码上的分页
    this.$nextTick(() => {
        this.$refs.pagination.internalCurrentPage = Number(this.curPage);
    })
    this.paperList();
    this.alreadyPaperList();
  },
  methods: {
    goPage(url) {
      this.$router.push(url);
    },
    paperList() {
      let url = this.$config.baseApi + "/examination/paper/history/list";
      this.$ajax({
        url: url,
        method: "post",
        data: JSON.stringify({
          useFlag:2, //2为未考
          current:this.curPage,
          pageSize:this.pageSize
        })
      })
        .then(res => {
          if (res.code == 1) {
            this.dataList = res.data.records;
            if(res.data.total == 0){
              this.isShow = true
            }
            this.dataInfo = res.data;
            this.loading = false;
            this.$config.waitTest = res.data.total
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    alreadyPaperList() {
      let url = this.$config.baseApi + "/examination/paper/history/list";
      this.$ajax({
        url: url,
        method: "post",
        data: JSON.stringify({
          useFlag:1, //1为已考
          current:this.curPage,
          pageSize:this.pageSize
        })
      })
        .then(res => {
          if (res.code == 1) {
            this.alreadyTotal = res.data.total
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 分页改变
    changePage(pageIndex) {
      this.curPage = pageIndex;
      this.paperList();
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/home/test.css";
.mainCont {
  background: #fff;
  padding: 0.23rem 0.2rem;
  margin-bottom: 0.2rem;
}
@media screen and (max-width: 768px) {
  .mainCont {
    display: none;
  }
  .mobileTest {
    display: block;
  }
}
</style>
